import * as React from 'react';

import Modal from 'app/components/Modal';
import Button from 'app/common/arctechv2/components/Button';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */
import baseCss from 'app/common/arctechv2/baseCss';

const modalStyle = css`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1060;
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	outline: 0;
	background: rgba(0, 0, 0, 0.3);
	line-height: 1.5;
	font-family: 'Inter', sans-serif;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	@-webkit-keyframes fadeIn {
		from {
		  opacity: 0;
		}
	  
		to {
		  opacity: 1;
		}
	  }
	  @keyframes fadeIn {
		from {
		  opacity: 0;
		}
	  
		to {
		  opacity: 1;
		}
	  }
	  
	  /*--keyframe pointer --*/
	  .fadeIn { 
		animation-name: fadeIn;
	  }
		
	.modal-dialog {
		animation-duration: .5s;
		animation-fill-mode: both;
		animation-delay: 0.1s;
		border-radius: 20px;
		max-height: calc(100vh - 100px);

		&.modal-dialog-large {
			max-width: 80vw;
		}

		width: 90%;
		margin: 40px auto;
		background: #fff;
		padding: 25px 20px;
		
		.modal-header {
			font-weight: 600;
			font-size: 16px;
			border-bottom: none;
			padding-bottom: 0;
		}
		
		.modal-footer {
			margin-top: 20px;
			button {
				margin-right: 10px;
			}
		}
		
		.modal-body {
			margin-top: 20px;
			font-size: 14px;
			font-weight: 500;
			color: #111928;
		}
	}

	.modal-content {
		position: relative;
	}
	.modal-close {
		position: absolute;
		top: 0;
		right: 0;
		font-size: 20px;
	}
`;

export default React.forwardRef(({ showing, bodyType, maxWidth, additionalButtons, buttonLabel, buttonDisabled, isLoading, onClick, setShowing, onHide, header, body, modalCss, size, dismissable = true }, ref) => {

	const onClose = () => {
		setShowing(false);
		onHide && onHide();
	}

	return showing ? <Modal>
		<div css={[modalStyle, baseCss]} onClick={() => {
			if (onHide && dismissable) {
				setShowing(false);
				onHide();	
			}
		}}>
			<div css={modalCss} style={{
				maxWidth: maxWidth ? maxWidth : 750
			}} className={`fadeIn modal-dialog ${size == 'large' ? 'modal-dialog-large' : ''}`} onClick={(ev) => {
				ev.stopPropagation();
				return false;
			}}>
				<div className="modal-content">
					<div className="modal-header">
						{header}
					</div>
					<div className={"modal-body "+(bodyType === 'form' ? 'modal-form': '')}>
						{body}
					</div>
					<div className="modal-footer">
						{additionalButtons}
						{buttonLabel && onClick && <Button onClick={onClick} disabled={buttonDisabled}>
							{isLoading ? <i className="fa-solid fa-spinner fa-spin" /> : buttonLabel}
						</Button>}
						{onHide && dismissable && <Button variant="invert" onClick={onClose} color="#111928">Close</Button>}
					</div>
					{onHide && dismissable && <button className="modal-close" onClick={onClose}>
						<i className="fa-solid fa-xmark"></i>
					</button>}
				</div>
			</div>
		</div>
		<div className="modal-backdrop fade show"></div>

	</Modal> : <div />
});